import * as React from 'react';
import { useParams } from 'react-router-dom';
import { ReportGroupUserView } from 'cb-model';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useCloneEntity,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { ReportMenu } from './ReportMenu';
import { useSetMaxWeekCommencing } from './useSetMaxWeekCommencing';

export const GroupWeekUserSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(ReportGroupUserView);
  useSetMaxWeekCommencing(queryOptions, setQueryOptions);
  const LocalReportGroupUserView = useCloneEntity(ReportGroupUserView, (clone) => {
    clone.fields.institution_group_id.listColumn = true;
    clone.fields.week_commencing.listColumn = true;
    clone.fields.user_id.listColumn = true;
  });
  const gCacheQueryItem = useCacheQuery(ReportGroupUserView, queryOptions);
  return (
    <>
      <PageTitle title="Group / Week / User Report" />
      <ReportMenu />
      <Section>
        <p>Bookings and Attendance per User per Group per Week, for Events and Users that belong to each Group.</p>
        <PaginatorAndListSettings
          entity={LocalReportGroupUserView}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
